import { Alert } from '@/ui/Alert/Alert'
import { Stack } from '@/ui/layout/Stack'
import { Text } from '@/ui/layout/Text'
import styles from './RecipeWarnings.module.css'

/** What an install does only in part (e.g. repositories outside the
 * connection's token scope), as one warning for the region; `lead` opens it. */
export function RecipeWarnings({
  warnings,
  lead,
}: {
  warnings: string[]
  lead?: string
}) {
  if (warnings.length === 0 && !lead) return null
  return (
    <Alert tone="warning">
      <Stack gap="space-4">
        {lead && <Text as="p">{lead}</Text>}
        {warnings.length > 0 && (
          <Stack as="ul" gap="space-4" className={styles.list}>
            {warnings.map((w) => (
              <Text as="li" key={w}>
                {w}
              </Text>
            ))}
          </Stack>
        )}
      </Stack>
    </Alert>
  )
}
